var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddPlus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.001,
    height: 22,
    viewBox: "0 0 22.001 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    d: "M11,22A11,11,0,0,1,3.222,3.222,11,11,0,1,1,18.779,18.778,10.929,10.929,0,0,1,11,22ZM6,10.184v1.633h4.124V16h1.752V11.816H16V10.184H11.876V6H10.124v4.184Z",
    fill: "#27a7df"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPlus);
export default __webpack_public_path__ + "static/media/add_plus.5e01c636ceb058740d8d0306b9481806.svg";
export { ForwardRef as ReactComponent };